import { useContext } from "react";
import NameChangesContext from "./NameChangesContext";

export default function useNameChanges() {
  return useContext(NameChangesContext);
}
